import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _toArray from "@babel/runtime-corejs2/helpers/toArray";
import _Number$parseFloat from "@babel/runtime-corejs2/core-js/number/parse-float";
import _Number$parseInt from "@babel/runtime-corejs2/core-js/number/parse-int";
import moment from 'moment';
import Counterpart from 'counterpart';
import enhanceTranslate from './enhanceTranslate';
var toMomentLocaleMap = {
  'zh-hans': 'zh-cn',
  'zh-hant': 'zh-tw'
};

// XXX: this is an attempt to type this arg
// do not hesitate to rename it if you have better.

var getSeparatorCount = function getSeparatorCount(str, sep) {
  return str.split(sep).length - 1;
};

// checks that each part is 3 char long (except for the first one)
var checkIntPart = function checkIntPart(part, otherSep) {
  var splittedInt = part.split(otherSep);
  if (splittedInt.length === 1) return true;
  return splittedInt.every(function (thousand, index) {
    if (index === 0) {
      return thousand.length <= 3;
    }
    return thousand.length === 3;
  });
};
var separationFn = function separationFn(amount, sep) {
  var formattedString = '';
  var otherSep = sep === '.' ? ',' : '.';
  var _amount$split = amount.split(sep),
    _amount$split2 = _toArray(_amount$split),
    intPart = _amount$split2[0],
    decimalParts = _amount$split2.slice(1);
  if (!checkIntPart(intPart, otherSep)) {
    return NaN;
  }
  decimalParts.forEach(function (split, index) {
    var tmp = '';
    if (split.length < 3 && index > 0) {
      return NaN;
    }
    if (split.length <= 2 && decimalParts.indexOf(split) === decimalParts.length - 1 && amount.split(sep).length === 2 && amount.split(otherSep).every(function (str, idx) {
      return idx > 0 ? str.length >= 3 : true;
    })) {
      tmp = amount.split(otherSep).join('').split(sep).join('.');
    } else if (split.length >= 3 && split.split(otherSep)[0].length === 3 && (split.split(otherSep)[1] ? split.split(otherSep)[1].length === 2 : true)) {
      tmp = amount.split(sep).join('').split(otherSep).join('.');
    }
    formattedString =
    // eslint-disable-next-line no-nested-ternary
    formattedString !== '' ? tmp === formattedString ? tmp : NaN : tmp;
    return formattedString;
  });
  return _Number$parseFloat("".concat(formattedString));
};

/**
 * Format an amount string provided by the user to a Number, understood by APIs.
 * Use the localeData provided by Intl polyfill to replace `group` and `decimal` symbols.
 * @param string   userAmount   An amount provided by the user, retrieved from a form input.
 * @return number
 */
var formatUserAmount = function formatUserAmount(userAmount_) {
  var userAmount = userAmount_.replace(/\s/g, '');
  var separators = [',', '.'];
  var regex = /[^[0-9\s,.]/gm;
  if (userAmount.match(regex)) {
    return NaN;
  }
  if (separators.every(function (sep) {
    return userAmount.indexOf(sep) === -1;
  })) {
    return _Number$parseInt(userAmount, 10);
  }
  if (getSeparatorCount(userAmount, ',') > 1 && getSeparatorCount(userAmount, '.') > 1) {
    return NaN;
  }
  return getSeparatorCount(userAmount, '.') === 1 ? separationFn(userAmount, '.') : separationFn(userAmount, ',');
};
var i18nDefaultParams = {
  translations: {},
  localeData: {},
  locale: 'en',
  defaultLocale: 'en',
  logMissing: false
};

/**
 * Create the translator.
 *
 * @param Object   i18n        Translations data and configuration
 * @param Function dispatch    Dispatch function used for logging
 * @return Object
 */
function createTranslator(i18n) {
  var logger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : console;
  var _i18n$translations = i18n.translations,
    translations = _i18n$translations === void 0 ? i18nDefaultParams.translations : _i18n$translations,
    _i18n$locale = i18n.locale,
    locale = _i18n$locale === void 0 ? i18nDefaultParams.locale : _i18n$locale,
    _i18n$defaultLocale = i18n.defaultLocale,
    defaultLocale = _i18n$defaultLocale === void 0 ? i18nDefaultParams.defaultLocale : _i18n$defaultLocale,
    _i18n$logMissing = i18n.logMissing,
    logMissing = _i18n$logMissing === void 0 ? i18nDefaultParams.logMissing : _i18n$logMissing,
    _i18n$localeData = i18n.localeData,
    localeData = _i18n$localeData === void 0 ? i18nDefaultParams.localeData : _i18n$localeData;
  var translator = new Counterpart.Instance();
  var availableLanguages = [locale, defaultLocale];

  // register only two locales: the current and the default.
  // no needs to register all available locales,
  // if the user change the locale, we reload the entire page.
  availableLanguages.forEach(function (locale_) {
    translator.registerTranslations(locale_, translations);
  });
  translator.setLocale(locale);

  // fall back to the default language when a translation
  // (or the pluralization function) is not found.
  translator.setFallbackLocale(defaultLocale);

  // use pipe separator in order to support dots in translations
  // Note: pipes are also used to handle our custom plural notation.
  // Counterpart will make nested dicts to handle plurals but everything works
  // as expected.
  translator.setSeparator('|');
  if (logger && global.__DEV__ && logMissing) {
    // display warning if the translation has not been found.
    var handleTranslationNotFound = function handleTranslationNotFound(requestedLocale, key) {
      logger.warn("Translation not found: ".concat(requestedLocale, " => \"").concat(key, "\""));
    };
    translator.onTranslationNotFound(handleTranslationNotFound);
  }

  // translate texts
  // Enchance the translate function with namespace, fallback, ...
  var translate = enhanceTranslate(i18n.scope, translator.translate.bind(translator), i18n.sanitize, logger);

  // translate date
  // (to avoid different tz between server and client, consider that all dates
  // are UTC)
  var localize = function localize(date) {
    var toUtc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return toUtc ? moment.utc(date).locale(toMomentLocaleMap[locale] || locale) : moment(date).locale(toMomentLocaleMap[locale] || locale);
  };

  /**
   * Create a `Intl.NumberFormat` with `options`.
   * Locale is auto injected from user configuration.
   */
  var createNumberFormat = function createNumberFormat(options) {
    return new Intl.NumberFormat(locale, _objectSpread({}, options));
  };

  /**
   * Return the currency symbol according to current locale from it's ISO code.
   * Use the localeData provided by Intl polyfill to map.
   * @param string   currencyISO   Currency ISO string
   * @return string
   */
  var mapCurrencyISOToSymbol = function mapCurrencyISOToSymbol(currencyISO) {
    var _localeData$number$cu, _localeData$number, _localeData$number$cu2;
    return (_localeData$number$cu = (_localeData$number = localeData.number) === null || _localeData$number === void 0 ? void 0 : (_localeData$number$cu2 = _localeData$number.currencies) === null || _localeData$number$cu2 === void 0 ? void 0 : _localeData$number$cu2[currencyISO]) !== null && _localeData$number$cu !== void 0 ? _localeData$number$cu : currencyISO;
  };
  return {
    translate: translate,
    localize: localize,
    createNumberFormat: createNumberFormat,
    mapCurrencyISOToSymbol: mapCurrencyISOToSymbol,
    formatUserAmount: formatUserAmount
  };
}
export default createTranslator;